'use client';

import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useAbTest } from '@packages/shared/src/abtesting/useAbTest/useAbTest';

import type { AppBannerVariant } from './types';

/** Maps the Lackmus treatment names of the AppBanner A/B/C test to our banner variants. */
const treatmentToVariant: Record<string, AppBannerVariant> = {
  control: 'control',
  test1: 'above',
  test2: 'below',
};

/**
 * Enrolls the user in the AppBanner A/B/C test (control/above/below) and resolves the variant.
 */
export const useAppBannerVariant = (): AppBannerVariant | undefined => {
  const {
    abTesting: { appBannerAbTestId: testId },
  } = useConfig();
  const { ruleset, isLoading, error } = useAbTest(testId!);

  if (isLoading) {
    return undefined;
  }

  if (error) {
    return 'control';
  }

  const treatment = ruleset?.variant?.treatment;
  const variant: AppBannerVariant = (treatment && treatmentToVariant[treatment]) || 'control';

  return variant;
};
